var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9502 6.59443L9.95021 13.7944C9.69101 14.2608 8.99181 13.872 9.25101 13.4056L13.251 6.20563C13.5102 5.73923 14.2094 6.12803 13.9502 6.59443Z",
    fill: "#00703A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85003 10.0873L9.85003 13.2873C10.266 13.6201 9.76683 14.2449 9.35083 13.9113L5.35083 10.7113C4.93483 10.3785 5.43403 9.75374 5.85003 10.0873Z",
    fill: "#00703A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 19.2C15.0808 19.2 19.2 15.0808 19.2 10C19.2 4.9192 15.0808 0.8 10 0.8C4.9192 0.8 0.8 4.9192 0.8 10C0.8 15.0808 4.9192 19.2 10 19.2ZM10 20C15.5232 20 20 15.5232 20 10C20 4.4768 15.5232 0 10 0C4.4768 0 0 4.4768 0 10C0 15.5232 4.4768 20 10 20Z",
    fill: "#00703A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.f91ed4b2d7a1508042a437fe8011d1a8.svg";
export { ForwardRef as ReactComponent };